import { t } from 'i18next';
import { SquareBadge, ThumbnailPhotoCard } from '@peacecover/component';
import { getPhotoCardBadges } from '../../trading/utils/getPhotoCardBadges';
import type { PhotoCardType } from '../../types/PhotoCardType';

interface TradingPhotoCardProps {
  photoCard: PhotoCardType;
  source?: string;
}

const TradingPhotoCard = ({ photoCard, source }: TradingPhotoCardProps) => {
  const badges = getPhotoCardBadges(photoCard);
  return (
    <div
      className="flex w-full items-center gap-[18px] px-[16px] py-[14px] bg-pure-white dark:bg-background-dark rounded-[18px]
shadow-[0_0_3px_0_rgba(0,0,0,0.10),_0_0_20px_0_rgba(0,0,0,0.08),_inset_0_0_0_1px_#E7E7E7]
dark:shadow-[0_0_3px_0_rgba(0,0,0,0.83),_0_0_20px_0_rgba(0,0,0,0.83),_inset_0_0_0_1px_#000000]"
    >
      <ThumbnailPhotoCard
        imageUrl={photoCard.mediumThumbnailUrl || photoCard.pictureUrl}
        className="w-[48px] h-[77px]"
      />
      <div className="flex flex-col gap-[6px] items-start leading-tight">
        <p className="text-[14px] font-medium text-text-main-lv2">
          {t('TradeReviewRequestPage.tradingPhotoCardName', {
            nickname: photoCard.memberName,
            categoryName: photoCard.categoryName,
            emoji: photoCard.categoryEmoji
          })}
        </p>
        <div className="flex flex-row gap-[4px] items-center">
          <p className="text-[13px] font-medium text-text-main-lv2">{photoCard.eventName}</p>
          {source && (
            <SquareBadge
              styleVariant="solid"
              colorVariant="gray"
              className="px-[5px] py-[3px] text-[12px] bg-surface-lv2 text-text-main-lv4"
            >
              {source}
            </SquareBadge>
          )}
        </div>
        {badges.length > 0 && (
          <SquareBadge
            styleVariant="line"
            colorVariant="gray"
            className="px-[5px] py-[3px] text-text-main-lv4"
          >
            {badges[0]}
          </SquareBadge>
        )}
      </div>
    </div>
  );
};

export default TradingPhotoCard;
